import React from "react";
// import "./index.css";
const Notifications = () => {
  return <div className="settings-tab">notifications</div>;
};
export default Notifications;
